/**
 * Format a 12-digit Aadhaar number with spaces every 4 digits for display.
 * Input must be 0-12 raw digits (callers strip non-digits beforehand).
 * Returns the formatted display string; the raw digits stay in state for
 * submission to the API (the backend's /^\d{12}$/ regex rejects spaces).
 *
 * Examples:
 *   formatAadhaar('')              → ''
 *   formatAadhaar('1234')          → '1234'
 *   formatAadhaar('12345678')      → '1234 5678'
 *   formatAadhaar('123456789012')  → '1234 5678 9012'
 */
export function formatAadhaar(digits: string): string {
  return digits.match(/.{1,4}/g)?.join(' ') ?? '';
}
